import UtilityHelper from "../utilities/UtilityHelper";
import StorageKeys from "../../const/StorageKeys";
//import { getFCMToken } from "../firebase/Firebase";

const NODE_ENV = process.env.NODE_ENV;

const CacheStorage = new (class CacheStorage {
  saveValue = (key: string, val: any) => {
    if (NODE_ENV === "production") {
      if (UtilityHelper.isNotEmpty(val)) {
        val = btoa(unescape(encodeURIComponent(val)));
      }
      localStorage.setItem(btoa(key), val);
    } else {
      localStorage.setItem(key, val);
    }
    //localStorage.setItem(key, JSON.stringify(val));
  };

  getValue = (key: string): string => {
    let val = localStorage.getItem(key) ?? "";

    if (NODE_ENV === "production") {
      val = localStorage.getItem(btoa(key)) ?? "";

      if (UtilityHelper.isNotEmpty(val)) {
        val = decodeURIComponent(escape(atob(val)));
      }
    }

    return val; //localStorage.getItem(key) ?? "";
    //const value: string = localStorage.getItem(key) ?? "";
    //return UtilityHelper.isNotEmpty(value) ? JSON.parse(value) : "";
  };

  deleteValue = (key: string) => {
    localStorage.removeItem(NODE_ENV === "production" ? btoa(key) : key);
  };

  clearAll = () => {
    //this.deleteValue(StorageKeys.device_token);
    //PushNotificationService().getFCMToken();
    //getFCMToken();

    this.deleteValue(StorageKeys.launch_status);
    this.deleteValue(StorageKeys.account_id);
    this.deleteValue(StorageKeys.name);
    this.deleteValue(StorageKeys.logo);
    this.deleteValue(StorageKeys.public_key);
    this.deleteValue(StorageKeys.private_key);
    this.deleteValue(StorageKeys.branch_id);
    this.deleteValue(StorageKeys.division_id);
    this.deleteValue(StorageKeys.division_title);
  };
})();

export default CacheStorage;
